import { executePost } from "../../Utils/ServiceMethods";
import { toast } from "react-toastify";
import { SessionTimeout } from "../../Utils/ErrorMessages";
import { removeUserCredentials } from "../../Utils/LocalStorage";

export const getMarketplaceUpdateApi = async (data, cb) => {
  try {
    const marketplace = await executePost("/marketplace-profile-update", data);
    const marketplaceData = marketplace.data ? marketplace.data : [];
    return marketplaceData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
